import {
	GetProjectTemplateContentPayload,
	GetProjectTemplateContentResponse,
	GetProjectTemplatesPayload
} from '../../../entities/ProjectHelper';
import { GetProjectTemplatesResponse } from '../../../entities/ProjectHelper/GetProjectTemplatesResponse';
import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'Studio', controller: string) => ({
	GetProjects: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjects'
	}),
	GetProjectsWithLoadOptions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjectsWithLoadOptions'
	}),
	GetForms: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetForms'
	}),
	GetFlows: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFlows'
	}),
	GetViews: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetViews'
	}),
	GetFormFields: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFormFields'
	}),
	GetUniqueIdentities: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetUniqueIdentities'
	}),
	GetDeployments: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDeployments'
	}),
	GetProjectFormStatuses: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjectFormStatuses'
	}),
	GetFormFieldsByControlType: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFormFieldsByControlType'
	}),
	GetControlColumns: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetControlColumns'
	}),
	GetFlowDocuments: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFlowDocuments'
	}),
	GetFormFieldsForArchive: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFormFieldsForArchive'
	}),
	DeleteProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteProject'
	}),
	OpenProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'OpenProject'
	}),
	GetDeletedProjects: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDeletedProjects'
	}),
	GetDeletedProjectsWithLoadOptions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDeletedProjectsWithLoadOptions'
	}),
	RestoreProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'RestoreProject'
	}),
	GetRelationalControls: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetRelationalControls'
	}),
	GetDeployAgentAllPublishments: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDeployAgentAllPublishments'
	}),
	UpdateFormControlSearchIndex: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateFormControlSearchIndex'
	}),
	GetProjectReports: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjectReports'
	}),
	GetOngoingProcessIds: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetOngoingProcessIds'
	}),
	GetProjectsWhereActionFormExist: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjectsWhereActionFormExist'
	}),
	GetActiveFlowProjectVersions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActiveFlowProjectVersions'
	}),
	GetActiveFlowProjectVersionsWithLoadOptions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActiveFlowProjectVersionsWithLoadOptions'
	}),
	GetProjectVersions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProjectVersions'
	}),
	UndoChanges: new PostMethod<any, any>({
		service,
		controller,
		method: 'UndoChanges'
	}),
	RestoreBackup: new PostMethod<any, any>({
		service,
		controller,
		method: 'RestoreBackup'
	}),
	DeleteProjectSourceCode: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteProjectSourceCode'
	}),
	EncryptProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'EncryptProject'
	}),
	GetProjectTemplateContent: new PostMethod<
		GetProjectTemplateContentResponse,
		GetProjectTemplateContentPayload
	>({
		service,
		controller,
		method: 'GetProjectTemplateContent'
	}),
	GetProjectTemplates: new PostMethod<GetProjectTemplatesResponse, GetProjectTemplatesPayload>({
		service,
		controller,
		method: 'GetProjectTemplates'
	})
});

export { getMethods };
